export default "__VITE_ASSET__B2fpxLdM__"